import React, { useEffect, useState } from "react";
import { Container, Segment, Header, Icon, Loader, Message } from "semantic-ui-react";
import { useSearchParams } from "react-router-dom";

const AceptarPresupuesto = () => {
  const [params] = useSearchParams();
  const [estado, setEstado] = useState("loading");
  const [mensaje, setMensaje] = useState("Procesando aceptación...");

  useEffect(() => {
    const aceptar = async () => {
      try {
        const cabInstId = params.get("cabInstId");
        const token = params.get("token");

        if (!cabInstId || !token) {
          setEstado("error");
          setMensaje("El enlace no es válido.");
          return;
        }

        const baseUrl = process.env.REACT_APP_ACEPTAR_PRESUPUESTO_FUNCTION_URL;

        const resp = await fetch(
          `${baseUrl}?cabInstId=${encodeURIComponent(cabInstId)}&token=${encodeURIComponent(token)}`
        );

        const text = await resp.text();

        if (!resp.ok) {
          setEstado("error");
          setMensaje(text || "No fue posible aceptar el presupuesto.");
          return;
        }

        setEstado("success");
        setMensaje("Presupuesto aceptado correctamente. Puedes cerrar esta ventana.");
      } catch (error) {
        setEstado("error");
        setMensaje("Ocurrió un error al aceptar el presupuesto.");
      }
    };

    aceptar();
  }, [params]);

  return (
    <Container style={{ marginTop: 60 }}>
      <Segment textAlign="center" padded="very">
        {estado === "loading" && (
          <>
            <Loader active inline="centered" size="large" />
            <Header as="h2" style={{ marginTop: 25 }}>
              Procesando aceptación
            </Header>
            <p>{mensaje}</p>
          </>
        )}

        {estado === "success" && (
          <Message positive icon>
            <Icon name="check circle" />
            <Message.Content>
              <Message.Header>Presupuesto aceptado</Message.Header>
              {mensaje}
            </Message.Content>
          </Message>
        )}

        {estado === "error" && (
          <Message negative icon>
            <Icon name="warning circle" />
            <Message.Content>
              <Message.Header>No se pudo procesar</Message.Header>
              {mensaje}
            </Message.Content>
          </Message>
        )}
      </Segment>
    </Container>
  );
};

export default AceptarPresupuesto;